import styled from "styled-components";
import {Table} from "antd";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;

    .ant-table-tbody > tr > td:last-child,
    .ant-table-thead > tr > th:last-child {
        white-space: nowrap;
    }
    @media screen and (max-width: 768px) {
        .ant-table table td {
            display: ${props => props.display};
            grid-template-columns: 1fr 1fr;       

            justify-content: center;
            align-items: center;
        }
        .ant-table-cell {
            flex-direction: column;
        }
        .ant-table table th {
            display: none;
        }
        .ant-table table td::before {
            font-weight: bold;
            padding-right: 5px;
        }
        .ant-table table tr td {
            padding: 6px 16px !important;
        }
        .ant-table table tr td:first-child {
            padding-top: 16px !important;
        }
        .ant-table table tr td:last-child {
            padding-bottom: 16px !important;
        }
        ${props => props.dataTitles.map((title, index) => 
            `.ant-table table td:nth-child(${index + 1})::before {
                content: "${title}: ";
            }`
        )}
        .ant-table table tr {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: block;
            -webkit-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            -moz-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
    }
`;

/** Icon action buttons on Hakediş table */
export const PaymentPeriodActionButton = styled(CustomButton)`
    &.ant-btn {
        background-color: ${({$bg}) => $bg} !important;
        border-color: ${({$bg}) => $bg} !important;
        color: ${({$fg}) => $fg} !important;
    }
    &.ant-btn:hover,
    &.ant-btn:focus {
        background-color: ${({$bg}) => $bg} !important;
        border-color: ${({$bg}) => $bg} !important;
        color: ${({$fg}) => $fg} !important;
        filter: brightness(0.94);
    }
    &.ant-btn:active {
        filter: brightness(0.88);
    }
    &.ant-btn[disabled],
    &.ant-btn[disabled]:hover {
        filter: none;
        opacity: 0.5;
        color: ${({$fg}) => $fg} !important;
        background-color: ${({$bg}) => $bg} !important;
        border-color: ${({$bg}) => $bg} !important;
    }
    &.ant-btn.ant-btn-loading .anticon {
        color: ${({$fg}) => $fg} !important;
    }
`;

export const ActionButtons = styled.div`
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
`;
